import "./globals.css";
import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Home, NotFound, About } from "src/pages";
import { Suspense } from "react";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";
import GalleryDetail from "./pages/GalleryDetail";
import Shop from "./pages/Shop";
import Cart from "./pages/Cart";
import PendingBookings from "./pages/PendingBookings";
import Wishlist from "./pages/Wishlist";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Checkout from "./pages/Checkout";
import MyAccount from "./pages/MyAccount";
import ProtectedRoutesProvider from "./context/ProtectedRoutes";
import VerifyEmail from "./pages/VerifyToken";
import AuthLayout from "./layout/AuthLayout";
import MainLayout from "./layout/MainLayout";
import ConfirmOrderPage from "./pages/ConfirmOrderPage";
import VerifyEmailNotice from "./pages/VerifyEmailNotice";
import Lookbook from "./pages/Lookbook";
import ResetPasswordPage from "./pages/ResetPasswordPage";



const router = createBrowserRouter([
	{
		path: "/",
		element: <AuthLayout />,
		// errorElement: <ErrorPage />,
		children: [
			{ path: "login", element: <Login /> },
			{ path: "register", element: <Register /> },
			{ path: "checkemail", element: <VerifyEmailNotice /> },
			{ path: "verify-email", element: <VerifyEmail /> },
		],
	},
	{
		path: "/",
		element: <MainLayout />,
		// errorElement: <ErrorPage />,
		children: [

			{ path: "pending", element: <PendingBookings /> },
			{ path: "wishlist", element: <Wishlist /> },
			{ path: "account", element: <MyAccount /> },
			{ path: "checkout", element: <Checkout /> },
			{ path: "finalize-order", element: <ConfirmOrderPage /> },
		]
	},
	{ index: true, element: <Home /> },
	{ path: "about", element: <About /> },
	{ path: "contact", element: <Contact /> },
	{ path: "gallery", element: <Gallery /> },
	{ path: "/gallery/:id", element: <GalleryDetail /> },
	{ path: "/lookbook/:id", element: <Lookbook /> },
	{ path: "shop", element: <Shop /> },
	{ path: "*", element: <NotFound /> },
	{ path: "product/:id", element: <Cart /> },
	{ path: "reset-password", element: <ResetPasswordPage /> },
]);

function App() {
	return (
		<Suspense fallback={true}>
			<ProtectedRoutesProvider>
				<RouterProvider router={router} />
			</ProtectedRoutesProvider>
		</Suspense>
	);
}

export default App;
